export default "__VITE_ASSET__7O8aYmYq__"